/* eslint-disable max-lines */
import {
  Autocomplete,
  Box,
  Button,
  createFilterOptions,
  Grid,
  InputLabel,
  OutlinedInput,
  Typography,
} from '@mui/material';
import { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import debounceLodash from 'lodash.debounce';
import { withRouter } from 'react-router-dom';
import LeadGenerationContext from '../../../context/LeadGenerationContext';
import { GenerateQRStyles as classes } from './GenerateQRStyles';
import { CustomSelect } from '../../LeadGeneration/CustomSelect/CustomSelect';
import {
  BRANCH_CODE,
  BRANCH_CODE_PLACEHOLDER,
  BRANCH_NAME,
  BRANCH_NAME_PLACEHOLDER,
  EMP_NAME_EMAIL,
  EMP_NO_PLACEHOLDER,
  EMPLOYEE_EMAIL,
  EMPLOYEE_NAME,
  EMPLOYEE_NUMBER,
  KNOCK_OFF_MSSG_BODY_EMPLOYER,
  MANDATORY_FIELD_ERR,
  REQUIRED,
} from '../../../constants';
import { CustomInput } from '../../LeadGeneration/CustomInput/CustomInput';
import CustomTooltip from '../../Tooltip/CustomTooltip';
import Loader from '../../Loader/Loader';
import {
  commonFunction,
  emailValidation,
  handlefocus,
  isKnockOffValueEmployer,
  nameChange,
  QRCodeinternalProducts,
} from '../../commonCode';
import KnockOffModal from '../../LeadGeneration/StepTwo/KnockOffModal';
import { CommonStyles } from '../../LeadGeneration/CommonStyles';
import { DGIProductUIStyles as styledClasses } from '../../DGI/DGIProductUIStyles';
import { getEmployeeDetails } from '../../../services/formService';
import { productNameURLMapping } from '../../../services/productNameURLMapping';

const GenerateQRInternalProduct = (props) => {
  const { t } = useTranslation();
  const [isModalEmployerValidate, setIsModalEmployerValidate] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [isExpandedEmpNum, setIsExpandedEmpNum] = useState(false);
  const [empNumResponse, setEmpNumResponse] = useState([]);

  const leadGenerationContext = useContext(LeadGenerationContext);
  const {
    isQrCodeDirty,
    setIsQrCodeDirty,
    qrCodeValInternalProduct,
    setQrCodeValInternalProduct,
    qrCodeValInternalProductError,
    setQrCodeValInternalProductError,
    setCurrentPage,
    setIsQR,
    theme,
    accessToken,
    setUserName,
    initiateUiResponse,
  } = leadGenerationContext;
  const { history } = props;
  const commonClass = CommonStyles(theme);

  const [isValidating, setIsValidating] = useState(false);
  useEffect(() => {
    document.title = `QR Code Internal Generation`;
    setCurrentPage('qr-internal-code');
    setIsQR(true);
  }, []);

  const validators = {
    empNum: (v) => /^[A-Za-z0-9]{1,15}$/.test(v), // Employee ID
    empName: (v) => /^[A-Za-zÁÉÍÓÚÜÑáéíóúüñ ]{1,50}$/.test(v),

    productName: (v) => /^[A-Za-z0-9+ ]{1,50}$/.test(v),

    branchCode: (v) => /^[1-9][0-9]{4}$/.test(v),
    branchName: (v) => !v || /^[A-Za-z0-9ÁÉÍÓÚÜÑáéíóúüñ ]{1,50}$/.test(v),
    custName: (v) => !v || /^[A-Za-z0-9@&_.\-\s,()]{1,40}$/.test(v),

    selectLang: (v) => /^[A-Za-z0-9]{1,10}$/.test(v),
    primaryOfficerNum: (v) => /^[1-9][0-9]{9}$/.test(v),
    inputEmpNum: (v) => /^[A-Za-z0-9]{1,15}$/.test(v),
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const valueWithoutLeadingSpace = value.replace(/^\s+/, '');
    if (name !== 'branchCode' && value !== '' && valueWithoutLeadingSpace === '') {
      setQrCodeValInternalProduct((prev) => ({ ...prev, [name]: '' }));
      setQrCodeValInternalProductError((prev) => ({ ...prev, [name]: '* Mandatory Field' }));
      return;
    }

    if (name === 'emailAdd') {
      if (
        valueWithoutLeadingSpace.match(
          /^([a-zA-Z0-9_.-]+)@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.)|(([a-zA-Z0-9-]+\.)+))([a-zA-Z]{2,4}|\d{1,3})(\]?)$/
        )
      ) {
        const emailFirstPart = valueWithoutLeadingSpace.split('@');
        const emailSecondPart = emailFirstPart[1]?.toLowerCase();
        if (!emailSecondPart.includes('orientalbank.com')) {
          setQrCodeValInternalProduct((prevState) => ({
            ...prevState,
            [name]: valueWithoutLeadingSpace,
          }));
          setQrCodeValInternalProductError((prevState) => ({
            ...prevState,
            [name]: '* Invalid Email Domain',
          }));
        } else if (
          emailFirstPart[0].charAt(0) !== '-' &&
          emailFirstPart[0].charAt(0) !== '.' &&
          emailFirstPart[0].charAt(emailFirstPart[0].length - 1) !== '.' &&
          emailFirstPart[0].charAt(emailFirstPart[0].length - 1) !== '-' &&
          !value.match(/[.\-_]{2,}/)
        ) {
          setQrCodeValInternalProduct((prevState) => ({
            ...prevState,
            [name]: valueWithoutLeadingSpace,
          }));
          setQrCodeValInternalProductError((prevState) => ({
            ...prevState,
            [name]: '',
          }));
        } else {
          setQrCodeValInternalProduct((prevState) => ({
            ...prevState,
            [name]: valueWithoutLeadingSpace,
          }));
          setQrCodeValInternalProductError((prevState) => ({
            ...prevState,
            [name]: '* Invalid Format',
          }));
        }
      } else if (valueWithoutLeadingSpace === '') {
        setQrCodeValInternalProduct((prevState) => ({
          ...prevState,
          [name]: '',
        }));
        setQrCodeValInternalProductError((prevState) => ({
          ...prevState,
          [name]: '* Mandatory Field',
        }));
      } else {
        setQrCodeValInternalProduct((prevState) => ({
          ...prevState,
          [name]: valueWithoutLeadingSpace,
        }));
        setQrCodeValInternalProductError((prevState) => ({
          ...prevState,
          [name]: '* Invalid Format',
        }));
      }
    } else {
      setQrCodeValInternalProduct((prev) => ({
        ...prev,
        [name]: valueWithoutLeadingSpace,
      }));
      setQrCodeValInternalProductError((prev) => ({
        ...prev,
        [name]: '',
      }));

      if (validators[name]) {
        const isValid = validators[name](valueWithoutLeadingSpace);

        if (name === 'custName' || name === 'empName' || name === 'branchCode')
          setQrCodeValInternalProductError((prev) => ({
            ...prev,
            [name]: isValid
              ? ''
              : name === 'custName'
              ? '* Invalid Commercial Customer'
              : `* Invalid format`,
          }));
      }
    }
  };

  const isFormValid = async () => {
    let valid = true;
    if (qrCodeValInternalProduct?.custName) {
      const validateEmployerVal = await isKnockOffValueEmployer(qrCodeValInternalProduct?.custName);
      if (validateEmployerVal) {
        valid = false;
        setIsModalEmployerValidate(true);
        setOpenModal(true);
      }
    }
    if (!qrCodeValInternalProduct?.custName) {
      valid = false;
      setQrCodeValInternalProductError((prevState) => ({
        ...prevState,
        custName: MANDATORY_FIELD_ERR,
      }));
    }
    if (!qrCodeValInternalProduct?.empNum) {
      valid = false;
      setQrCodeValInternalProductError((prevState) => ({
        ...prevState,
        empNum: MANDATORY_FIELD_ERR,
      }));
    }
    if (!qrCodeValInternalProduct?.empName) {
      valid = false;
      setQrCodeValInternalProductError((prevState) => ({
        ...prevState,
        empName: MANDATORY_FIELD_ERR,
      }));
    }

    if (!qrCodeValInternalProduct?.emailAdd) {
      valid = false;
      setQrCodeValInternalProductError((prevState) => ({
        ...prevState,
        emailAdd: MANDATORY_FIELD_ERR,
      }));
    }
    if (!qrCodeValInternalProduct?.branchCode) {
      valid = false;
      setQrCodeValInternalProductError((prevState) => ({
        ...prevState,
        branchCode: MANDATORY_FIELD_ERR,
      }));
    }
    if (!qrCodeValInternalProduct?.productName) {
      valid = false;
      setQrCodeValInternalProductError((prevState) => ({
        ...prevState,
        productName: MANDATORY_FIELD_ERR,
      }));
    }
    if (!qrCodeValInternalProduct?.selectLang) {
      valid = false;
      setQrCodeValInternalProductError((prevState) => ({
        ...prevState,
        selectLang: MANDATORY_FIELD_ERR,
      }));
    }
    for (const key in qrCodeValInternalProductError) {
      if (qrCodeValInternalProductError[key]) {
        valid = false;
        break;
      }
    }
    return valid;
  };

  const handleContinue = async (e) => {
    e.preventDefault();

    const valid = await isFormValid();
    if (isQrCodeDirty && valid) {
      setIsValidating(true);
      const validation = await emailValidation(
        qrCodeValInternalProductError,
        qrCodeValInternalProduct,
        leadGenerationContext,
        setQrCodeValInternalProductError
      );
      const prodDetails = QRCodeinternalProducts?.find(
        (x) => x.productText === qrCodeValInternalProduct.productName
      );

      if (valid && validation && validation?.valid === true) {
        setIsValidating(false);
        history.push({
          pathname: `/${productNameURLMapping(
            prodDetails.productNameUI
          )}/${leadGenerationContext.language?.toLowerCase()}/qr-info`,
          state: prodDetails,
        });
      } else {
        setIsValidating(false);
        const fields = [
          'productName',
          'selectLang',
          'branchCode',
          'branchName',
          'emailAdd',
          'empNum',
          'empName',
          'custName',
        ];
        handlefocus(qrCodeValInternalProductError, setIsValidating, fields);
      }
    } else if (valid) {
      setIsValidating(false);
      setIsQrCodeDirty(false);
      history.push({
        pathname: `/${productNameURLMapping(
          leadGenerationContext.productName
        )}/${leadGenerationContext.language?.toLowerCase()}/qr-info`,
      });
    }
  };

  const debouncedSearchEmpNum = useMemo(
    () =>
      debounceLodash(async (value, token, setResponse, uiConfig) => {
        if (value && value.length >= 3) {
          const query = `empID=${value}`;
          const empIDresponse = await getEmployeeDetails(query, token, uiConfig);

          if (empIDresponse?.status === 200) {
            setResponse(empIDresponse?.data);
          } else {
            history.push({
              pathname: `/${leadGenerationContext.language?.toLowerCase()}/fallback`,
            });
          }
        } else {
          setEmpNumResponse([]);
        }
      }, 500),
    []
  );

  useEffect(
    () => () => {
      debouncedSearchEmpNum?.cancel();
    },
    [debouncedSearchEmpNum]
  );

  const filterOptions = (options, { inputValue }) => {
    const search = inputValue.toLowerCase();

    return options.filter((opt) => String(opt).toLowerCase().includes(search));
  };

  const handleEmpNumChange = (e, selectedValue) => {
    if (!selectedValue) return;

    const selectedObj = Array.isArray(empNumResponse)
      ? empNumResponse.find((item) => item['Employee ID'] === selectedValue)
      : null;
    if (selectedObj) {
      const email = selectedObj['Employee Email'] || '';
      const domain = email.split('@')[1]?.toLowerCase() || '';
      const emailError = !email
        ? '* Mandatory Field'
        : !domain.includes('orientalbank.com')
        ? '* Invalid Email Domain'
        : '';

      setQrCodeValInternalProduct((prev) => ({
        ...prev,
        empNum: selectedObj['Employee ID'],
        empName: selectedObj['Employee Name'],
        emailAdd: email,
        branchCode: selectedObj['Branch Code'],
        branchName: selectedObj['Branch Name'],
        primaryOfficerNum: selectedObj['Primary Officer Number'],
        isAutoPopulatedEmpNum: true,
      }));
      setUserName(selectedObj['Employee Name']?.split(' ')[0]);
      setQrCodeValInternalProductError((prev) => ({
        ...prev,
        empName: '',
        emailAdd: emailError,
        empNum: '',
        branchCode: '',
        branchName: '',
      }));
    }
  };

  return (
    <Box component="div" sx={classes.topContainer}>
      <Box component="div" sx={classes.subContainer}>
        <Typography style={{ padding: '28px 30px 24px 30px' }} sx={classes.headingNew}>
          {t('Internal QR Generation Part1', {
            defaultValue: 'QR C',
          })}
          <span style={{ color: '#E37617' }}>
            {t('Internal QR Generation Highlight', {
              defaultValue: 'o',
            })}
          </span>
          {t('Internal QR Generation Part2', {
            defaultValue: 'de Internal Generation',
          })}
        </Typography>
        <div style={{ padding: '30px' }}>
          <Typography sx={classes.subHead}>
            {t('Generate QR Code Internal', {
              defaultValue: 'Generate QR Code',
            })}
          </Typography>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, md: 6 }} sx={classes.field_padding_finance}>
              <InputLabel
                htmlFor="empNo"
                required
                id="empNo_label"
                data-testid="empNo_testid"
                aria-label={`${t(EMPLOYEE_NUMBER, { defaultValue: EMPLOYEE_NUMBER })} ${t(
                  REQUIRED,
                  {
                    defaultValue: REQUIRED,
                  }
                )}`}
                sx={commonClass.label_title}
              >
                {t(EMPLOYEE_NUMBER, { defaultValue: EMPLOYEE_NUMBER })}
              </InputLabel>
              <Autocomplete
                id="empNum"
                data-testid="autocomplete"
                name="empNum"
                noOptionsText=""
                getOptionLabel={(option) => option}
                value={commonFunction(qrCodeValInternalProduct?.empNum)}
                inputValue={qrCodeValInternalProduct.inputEmpNum || ''}
                onInputChange={(_event, value) => {
                  if (value.startsWith(' ')) {
                    setQrCodeValInternalProduct((prev) => ({ ...prev, inputEmpNum: '' }));
                    setQrCodeValInternalProductError((prev) => ({
                      ...prev,
                      empNum: '* Mandatory Field',
                    }));
                    return;
                  }
                  const inputValue = value.replace(/^\s+/, '').slice(0, 15);
                  setQrCodeValInternalProduct((prev) => ({ ...prev, inputEmpNum: inputValue }));
                  const hasSpecialChars = /[^A-Za-z0-9]/.test(inputValue);
                  if (hasSpecialChars) {
                    setQrCodeValInternalProductError((prev) => ({
                      ...prev,
                      empNum: '* Invalid Format',
                    }));
                  } else {
                    setQrCodeValInternalProductError((prev) => ({
                      ...prev,
                      empNum: '',
                    }));
                    if (inputValue) {
                      debouncedSearchEmpNum(
                        inputValue,
                        accessToken,
                        setEmpNumResponse,
                        initiateUiResponse
                      );
                    }
                  }
                }}
                onChange={(_event, selectedValue) => {
                  handleEmpNumChange(_event, selectedValue);
                }}
                options={
                  qrCodeValInternalProduct.inputEmpNum?.length >= 3 && Array.isArray(empNumResponse)
                    ? empNumResponse.map((item) => item['Employee ID'])
                    : []
                }
                open={
                  isExpandedEmpNum &&
                  qrCodeValInternalProduct?.inputEmpNum?.length >= 3 &&
                  empNumResponse?.length > 0
                }
                onOpen={() => setIsExpandedEmpNum(true)}
                onClose={(event, reason) => {
                  const isAndroid = /Android/i.test(navigator.userAgent);
                  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
                  if (reason === 'blur' && isIOS) return;
                  if (reason === 'blur' && isAndroid) {
                    setTimeout(() => setIsExpandedEmpNum(false), 800);
                    return;
                  }
                  setIsExpandedEmpNum(false);
                }}
                onKeyDown={(e) => {
                  const { key } = e;
                  if (e.ctrlKey || e.metaKey) return;
                  const allowedControlKeys = [
                    'Backspace',
                    'Delete',
                    'ArrowLeft',
                    'ArrowRight',
                    'Tab',
                  ];
                  if (allowedControlKeys.includes(key)) return;

                  const currentValue = qrCodeValInternalProduct.inputEmpNum || '';

                  if (currentValue.length >= 15) {
                    e.preventDefault();
                    return;
                  }

                  if (key === 'Enter') {
                    const typed = qrCodeValInternalProduct.inputEmpNum;

                    const options = Array.isArray(empNumResponse)
                      ? empNumResponse.map((item) => item['Employee ID'])
                      : [];

                    if (options.includes(typed)) {
                      e.preventDefault();
                      handleEmpNumChange(e, typed);
                    }
                  }
                }}
                renderInput={(params) => (
                  <OutlinedInput
                    onFocus={() => setIsExpandedEmpNum(true)}
                    id="empNum"
                    name="empNum"
                    autoFocus
                    inputProps={{ ...params.inputProps, maxLength: 15 }}
                    ref={params.InputProps.ref}
                    slotProps={{
                      notchedOutline: {
                        sx: !qrCodeValInternalProductError.empNum
                          ? commonClass.notchedOutline
                          : commonClass.notchedOutlineErr,
                      },
                    }}
                    sx={{
                      ...commonClass.outlined_inputs,
                    }}
                    placeholder={t(EMP_NO_PLACEHOLDER, {
                      defaultValue: EMP_NO_PLACEHOLDER,
                    })}
                    fullWidth
                    value={commonFunction(qrCodeValInternalProduct?.empNum)}
                  />
                )}
                filterOptions={filterOptions}
              />
              <Box
                component="span"
                role="alert"
                sx={styledClasses.error_message_product}
                data-testid="empNumErr-id"
              >
                {t(qrCodeValInternalProductError.empNum, {
                  defaultValue: qrCodeValInternalProductError.empNum,
                })}
              </Box>
            </Grid>

            <Grid size={{ xs: 12, md: 6 }} sx={classes.field_padding_finance}>
              <CustomInput
                name="empName"
                id="empName"
                dataTestId="empName_id"
                required
                inputLabelAriaLabel={`${t(EMPLOYEE_NAME, {
                  defaultValue: EMPLOYEE_NAME,
                })} ${t(REQUIRED, { defaultValue: REQUIRED })}`}
                label={t(EMPLOYEE_NAME, { defaultValue: EMPLOYEE_NAME })}
                // autoFocus
                handleChange={handleChange}
                disabled={qrCodeValInternalProduct.isAutoPopulatedEmpNum}
                placeholder={t('Enter Employee Name Internal', {
                  defaultValue: 'Enter Employee Name',
                })}
                fullWidth
                handleBlur={() =>
                  setQrCodeValInternalProduct((prevState) => ({
                    ...prevState,
                    empName: qrCodeValInternalProduct?.empName
                      ? qrCodeValInternalProduct?.empName
                      : '',
                  }))
                }
                inputProps={{ maxLength: 50, 'data-testid': 'first-name' }}
                value={qrCodeValInternalProduct?.empName ? qrCodeValInternalProduct.empName : ''}
                error={
                  qrCodeValInternalProductError?.empName
                    ? qrCodeValInternalProductError.empName
                    : ''
                }
              />
              <Box component="span" sx={classes.error_message} role="alert">
                {t(qrCodeValInternalProductError?.empName, {
                  defaultValue: qrCodeValInternalProductError?.empName,
                })}
              </Box>
            </Grid>

            <Grid size={{ xs: 12, md: 6 }} sx={classes.field_padding_finance}>
              <CustomInput
                id="emailAdd"
                dataTestId="emailAdd_id"
                required
                inputLabelAriaLabel={`${t(EMPLOYEE_EMAIL, {
                  defaultValue: EMPLOYEE_EMAIL,
                })} ${t(REQUIRED, { defaultValue: REQUIRED })}`}
                label={t(EMPLOYEE_EMAIL, { defaultValue: EMPLOYEE_EMAIL })}
                // autoFocus
                handleChange={handleChange}
                disabled={qrCodeValInternalProduct.isAutoPopulatedEmpNum}
                placeholder={t(EMP_NAME_EMAIL, {
                  defaultValue: EMP_NAME_EMAIL,
                })}
                fullWidth
                inputProps={{ 'data-testid': 'email', maxLength: 40 }}
                value={qrCodeValInternalProduct?.emailAdd ? qrCodeValInternalProduct.emailAdd : ''}
                error={
                  qrCodeValInternalProductError?.emailAdd
                    ? qrCodeValInternalProductError.emailAdd
                    : ''
                }
              />

              <Box component="span" sx={classes.error_message} role="alert">
                {t(qrCodeValInternalProductError.emailAdd, {
                  defaultValue: qrCodeValInternalProductError.emailAdd,
                })}
              </Box>
            </Grid>
            {/* 
            <Grid size={{ xs: 12, md: 6 }} sx={classes.field_padding_finance}>
              <CustomSelect
                id="productCat"
                dataTestId="productCat_testid"
                required
                inputLabelAriaLabel={`${t('Product Category', {
                  defaultValue: 'Product Category',
                })} `}
                label={t('Product Category', { defaultValue: 'Product Category' })}
                options={['Checking']}
                nsSeparator="|"
                handleChange={handleChange}
                fullWidth
                value={qrCodeValInternalProduct.productCat ? qrCodeValInternalProduct.productCat : ''}
                selectAriaLabel={`${t('Aria Label Product Category', {
                  defaultValue:
                    'Product Category Required Select Product Category dropdown menu button',
                })} ${t(REQUIRED, { defaultValue: REQUIRED })}`}
                error={
                  qrCodeValInternalProductError.productCat ? qrCodeValInternalProductError.productCat : ''
                }
              />

              <Box component="span" sx={classes.error_message} role="alert">
                {t(qrCodeValInternalProductError.productCat, {
                  defaultValue: qrCodeValInternalProductError.productCat,
                })}
              </Box>
            </Grid> */}
            <Grid size={{ xs: 12, md: 6 }} sx={classes.field_padding_finance}>
              <CustomSelect
                id="productName"
                dataTestId="productName_testid"
                required
                inputLabelAriaLabel={`${t('Product Name Internal', {
                  defaultValue: 'Product Name',
                })} `}
                label={t('Product Name Internal', { defaultValue: 'Product Name' })}
                options={['Libre', 'Ahorra', 'Elite', 'Libre+']}
                nsSeparator="|"
                handleChange={handleChange}
                fullWidth
                value={
                  qrCodeValInternalProduct.productName ? qrCodeValInternalProduct.productName : ''
                }
                selectAriaLabel={`${t('Aria Label productName', {
                  defaultValue: 'productName Required Select productName dropdown menu button',
                })} ${t(REQUIRED, { defaultValue: REQUIRED })}`}
                error={
                  qrCodeValInternalProductError.productName
                    ? qrCodeValInternalProductError.productName
                    : ''
                }
              />

              <Box component="span" sx={classes.error_message} role="alert">
                {t(qrCodeValInternalProductError.productName, {
                  defaultValue: qrCodeValInternalProductError.productName,
                })}
              </Box>
            </Grid>

            <Grid size={{ xs: 12, md: 6 }} sx={classes.field_padding_finance}>
              <CustomInput
                id="branchCode"
                dataTestId="branchCode_id"
                required
                inputLabelAriaLabel={`${t(BRANCH_CODE, {
                  defaultValue: BRANCH_CODE,
                })} ${t(REQUIRED, { defaultValue: REQUIRED })}`}
                label={t(BRANCH_CODE, { defaultValue: BRANCH_CODE })}
                handleChange={handleChange}
                placeholder={t(BRANCH_CODE_PLACEHOLDER, {
                  defaultValue: BRANCH_CODE_PLACEHOLDER,
                })}
                fullWidth
                inputProps={{ maxLength: 15 }}
                value={
                  qrCodeValInternalProduct?.branchCode ? qrCodeValInternalProduct.branchCode : ''
                }
                error={
                  qrCodeValInternalProductError?.branchCode
                    ? qrCodeValInternalProductError.branchCode
                    : ''
                }
              />

              <Box component="span" sx={classes.error_message} role="alert">
                {t(qrCodeValInternalProductError.branchCode, {
                  defaultValue: qrCodeValInternalProductError.branchCode,
                })}
              </Box>
            </Grid>

            <Grid size={{ xs: 12, md: 6 }} sx={classes.field_padding_finance}>
              <CustomInput
                id="branchName"
                dataTestId="branchName_id"
                inputLabelAriaLabel={`${t(BRANCH_NAME, {
                  defaultValue: BRANCH_NAME,
                })}`}
                label={t(BRANCH_NAME, { defaultValue: BRANCH_NAME })}
                disabled
                handleChange={handleChange}
                placeholder={t(BRANCH_NAME_PLACEHOLDER, {
                  defaultValue: BRANCH_NAME_PLACEHOLDER,
                })}
                fullWidth
                inputProps={{ maxLength: 50 }}
                value={
                  qrCodeValInternalProduct?.branchName ? qrCodeValInternalProduct.branchName : ''
                }
                error={
                  qrCodeValInternalProductError?.branchName
                    ? qrCodeValInternalProductError.branchName
                    : ''
                }
              />

              <Box component="span" sx={classes.error_message} role="alert">
                {t(qrCodeValInternalProductError.branchName, {
                  defaultValue: qrCodeValInternalProductError.branchName,
                })}
              </Box>
            </Grid>

            <Grid
              size={{ xs: 12, md: 6 }}
              sx={{
                ...classes.field_padding_finance,
                '& .MuiInputLabel-root[for="custName"]': {
                  marginBottom: '0 !important',
                  display: 'none',
                },
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <InputLabel
                  required
                  sx={{
                    ...classes.labelStyle,
                    '& .MuiFormLabel-asterisk': {
                      color: '#d32f2f',
                      display: 'inline',
                    },
                  }}
                >
                  {t('Commercial Customer', {
                    defaultValue: 'Commercial Customer',
                  })}
                </InputLabel>

                <Box
                  component="span"
                  sx={{
                    color: '#e37617',
                    ml: 0.5,
                    fontSize: '22px',
                    fontFamily: 'Arial, sans-serif',
                    opacity: 1,
                  }}
                >
                  *
                </Box>

                <Box sx={{ ml: 1 }}>
                  <CustomTooltip
                    customAriaLabel="Name Included field"
                    text={t('nameTooltip', {
                      defaultValue:
                        'Name included on this field will be sent to FIS as the employer.',
                    })}
                  />
                </Box>
              </Box>
              <CustomInput
                id="custName"
                dataTestId="custName_id"
                inputLabelClassName={classes.labelStyleNew}
                inputLabelAriaLabel={`${t('Commercial Customer', {
                  defaultValue: 'Commercial Customer',
                })} `}
                // autoFocus
                handleChange={handleChange}
                placeholder={t('Enter Internal Customer Name', {
                  defaultValue: 'Enter Customer Name',
                })}
                fullWidth
                inputProps={{ maxLength: 40 }}
                value={qrCodeValInternalProduct?.custName ? qrCodeValInternalProduct.custName : ''}
                error={
                  qrCodeValInternalProductError?.custName
                    ? qrCodeValInternalProductError.custName
                    : ''
                }
              />

              <Box component="span" sx={classes.error_message} role="alert">
                {t(qrCodeValInternalProductError.custName, {
                  defaultValue: qrCodeValInternalProductError.custName,
                })}
              </Box>
            </Grid>

            <Grid size={{ xs: 12, md: 6 }} sx={classes.field_padding_finance}>
              <CustomSelect
                id="selectLang"
                dataTestId="selectLang_testid"
                required
                inputLabelAriaLabel={`${t('Language', {
                  defaultValue: 'Language',
                })} `}
                label={t('Language', { defaultValue: 'Language' })}
                options={['English', 'Spanish']}
                nsSeparator="|"
                handleChange={handleChange}
                fullWidth
                value={
                  qrCodeValInternalProduct.selectLang ? qrCodeValInternalProduct.selectLang : ''
                }
                selectAriaLabel={`${t('Aria Label Language', {
                  defaultValue: 'Language Required Select Language dropdown menu button',
                })} ${t(REQUIRED, { defaultValue: REQUIRED })}`}
                error={
                  qrCodeValInternalProductError.selectLang
                    ? qrCodeValInternalProductError.selectLang
                    : ''
                }
              />

              <Box component="span" sx={classes.error_message} role="alert">
                {t(qrCodeValInternalProductError.selectLang, {
                  defaultValue: qrCodeValInternalProductError.selectLang,
                })}
              </Box>
            </Grid>
          </Grid>
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              marginTop: '30px',
            }}
          >
            <Button
              disableFocusRipple
              disabled={isValidating}
              onClick={handleContinue}
              sx={classes.continue_button}
              data-testid="conti_testid"
            >
              {t('Generate QR Code Internal', {
                defaultValue: 'Generate QR Code',
              })}
            </Button>
          </div>
        </div>
      </Box>
      {isValidating && (
        <div className="loader-style">
          <Loader />
        </div>
      )}
      {isModalEmployerValidate && (
        <KnockOffModal
          message={{ message: KNOCK_OFF_MSSG_BODY_EMPLOYER, isKnockOff: true }}
          setIsModal={setOpenModal}
          openModal={openModal}
        />
      )}
    </Box>
  );
};

export default withRouter(GenerateQRInternalProduct);
GenerateQRInternalProduct.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
};
